import { createContext, useContext, useEffect } from 'react';

import { useAuthCtx } from '@/components/providers/auth-provider';
import { ApiSchemas, useApiV1Ctx } from '@/components/providers/v1-api';

interface Context {
  me: ApiSchemas['EmployeeRead'] | undefined;
}

const Context = createContext<Context | null>(null);

export function useMeCtx() {
  const ctx = useContext(Context);
  if (!ctx) {
    throw new Error('useMeCtx must be used within a EmployeeMeProvider');
  }
  return ctx;
}

export function EmployeeMeProvider({ children }: { children: React.ReactNode }) {
  const { api } = useApiV1Ctx();
  const { data: me } = api.employees.meEmployeesMeGet.useQuery(undefined, {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
  const { setIsAdmin } = useAuthCtx();

  useEffect(() => {
    if (me?.role === 'ADMIN') {
      setIsAdmin(true);
    }
  }, [me?.role, setIsAdmin]);

  return <Context.Provider value={{ me: me }}>{children}</Context.Provider>;
}
